import React, { useState } from "react";
import { setPage, setTaxId } from "../../../../stores/WashingStore/WashingStore";
import { PAGES } from "../../../../stores/WashingStore/WashingStore.types";
import TotemSkeleton from "../../components/TotemSkeleton/TotemSkeleton";
import TotemButton from "../../components/TotemButton/TotemButton";
import CustomKeyboard from "../../../../components/CustomKeyboard/CustomKeyboard";
import { TextField } from "@mui/material";
import { Wrapper, KeyboardWrapper, TextWrapper } from "./ChooseTaxStyles";

const ChooseTax: React.FC = () => {
  const [taxId, setTaxIdState] = useState("");

  const handleNext = () => {
    if (taxId.length !== 11) return;
    setTaxId(taxId);
    setPage(PAGES.SEND_RECEIPT);
  };

  const handleSkip = () => {
    setPage(PAGES.SEND_RECEIPT);
  };

  const Buttons = (
    <>
      <TotemButton
        onClick={handleSkip}
        text="Pular"
      />
      <TotemButton
        onClick={handleNext}
        text="Avançar"
        disabled={taxId.length !== 11}
      />
    </>
  );

  return (
    <TotemSkeleton title="Identificação do Cliente" buttons={Buttons}>
      <Wrapper>
        <TextWrapper>
          <TextField
            fullWidth
            placeholder="CPF"
            variant="outlined"
            value={taxId}
            onChange={e => setTaxIdState(e.target.value.replace(/\D/g, ""))}
            slotProps={{
              htmlInput: { style: { fontSize: 32, textAlign: 'center' } }
            }}
            style={{ marginBottom: "2rem" }}
          />
        </TextWrapper>
        <KeyboardWrapper>
          <CustomKeyboard setValue={setTaxIdState} type="number" />
        </KeyboardWrapper>
      </Wrapper>
    </TotemSkeleton>
  );
};

export default ChooseTax;
